























import useChatInput from "@/composables/v3/useChatInput";
import { useChatsStore } from "@/store/useChatsStore";
import { isMobile } from "@/utils/mobile";
import { defineComponent, PropType, ref } from "@vue/composition-api";
import { onClickOutside } from "@vueuse/core";
import { BFormTextarea, BInputGroup, BLink } from "bootstrap-vue";
import { VEmojiPicker } from "v-emoji-picker";

export default defineComponent({
    components: { BLink, BFormTextarea, BInputGroup, VEmojiPicker },
    props: {
        component: {
            type: String as PropType<"container" | "button">,
            required: true,
        },
    },
    setup() {
        const chatsStore = useChatsStore();
        const { selectEmoji, shallShowEmojiPicker } = useChatInput();

        const emojiPickerElement = ref(null);

        onClickOutside(emojiPickerElement, () => (shallShowEmojiPicker.value = false));

        return {
            emojiPickerElement,
            chatsStore,
            selectEmoji,
            shallShowEmojiPicker,
            isMobile,
        };
    },
});
